

import axios from "axios";
import cn from "classnames";

import styles from "./Tracking.module.scss";
import Table from "../../components/common/Table";
import google from "google-map-react";

import Master from "screen/Master";
import GoogleMapMarker from "components/googlemap/GoogleMapMaker";
import Search from "../../components/common/Search";
import Button from "@material-ui/core/Button";
import { getRequest } from "services/axiosBaseClient";
import Geocode from "react-geocode";
import LocalStorageService from "services/tokenlocalstorage.service";
import React, {useState, useEffect, useRef,ComMapponent, useCallback} from "react";
import { Link } from "react-router-dom";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import moment from "moment";
// import {GoogleMap,useLoadScript,Marker} from "@react-google-maps/api";    commented this line due to npm installation issuse
export default function Track(props) {
  
  

function TrackView(props) {
  const columns = React.useMemo(() => [
    {
      Header: "Sr No.",
      accessor: "totalNo",
    },
    {
      Header: "Address",
      accessor: "address",
    },
    {
      Header: "Start Time",
      accessor: "startTime",
    },
    {
      Header: "End Time",
      accessor: "endtime",
    },
    {
      Header: "Miles",
      accessor: "miles",
    },
    {
      Header: "Duration",
      accessor: "duration",
    },
  ]);

  const filterInitialValue = {
    siteId: "",
    chargerId: "",
    state: "",
    city: "",
    zoneId: "",
    time: "HOUR_24",
  };
  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [alert, setAlert] = useState([]);
  const [filter, setFilter] = useState(filterInitialValue);
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [selectTime, setSelectTime] = useState("HOUR_24");

  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [addressTest, setAddressTest] = useState([])
  const [Coords, setCoords] = useState([{
    "lat": 28.595650,
    "lng": 77.343940,
    "id":1
    }]);
  const refOpen = useRef(open);
  const [addressBar,setAddressBar] = useState("");
  // const addressData = useCallback(async (latitude,longitude)=>{
    const addressData =  (latitude,longitude)=>{
    Geocode.fromLatLng(latitude , longitude,'AIzaSyAWSfp11ay0zsj1xJ5aiNwZcZgz73CHTvs').then(
      (response) => {
        console.log('dddd',response)
        // address = response.results[0].formatted_address;
        // setAddressBar(response.results[0].formatted_address);
        // console.log('api call',response.results[0].formatted_address);
        // console.log('api call addressBar',addressBar,'dfgdfg');
        setAddressTest(response?.results[0]?.formatted_address)
        return response.results[0].formatted_address;
      },
      (error) => {
        // console.log('irfan');
        console.error(error);
      }
    );
  
  }

  console.log('adddddddddddddd', addressTest);
  // );
  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
    if (event.target.name == "time") {
      setSelectTime(event.target.value);
    }
    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, chargerId: "" });
      // getChargers(event.target.value);
    }
  };
  const handleClick = () => {
    if (open) {
      setSelectTimeValue(selectTime);
      // getEnergyGraph(filter);
      // getSwappingGraph(filter);
      // getFaultGraph(filter);
      // getBatteryCountAndStatus(filter);
      setOpen(false);
    } else {
      setOpen(true);
    }
  };
var Coords1 = [

    {
      "lat": 28.595650,
      "lng": 77.343940,
      // "time": "2022-06-22 06:43:42.215607"
      },
      {
        "lat":28.461448,
        "lng": 78.023107,
        // "time": "2022-06-22 06:43:42.215607"
      },
      {
        "lat": 28.595650,
        "lng": 75.343940,
        // "time": "2022-06-22 06:43:42.215607"
        },
        {
          "lat":29.461448,
          "lng": 78.023107,
          // "time": "2022-06-22 06:43:42.215607"
        },
  
        {
          "lat":30.461448,
          "lng": 79.023107,
          // "time": "2022-06-22 06:43:42.215607"
        },
        {
          "lat":31.461448,
          "lng": 80.023107,
          // "time": "2022-06-22 06:43:42.215607"
        },

  ];
  // setCoords(Coords1);
  const TrackData = async(filter,batterySerial) => {
    var arr1 = [];
    var arr2 = [];
     await getRequest("track?batterySerialNumber=" + batterySerial)
      .then((res) => {
        if (res && res?.data && res?.data?.length >= 1) {
          console.log('result',res?.data)
          var i=1;
          var addressline = "";
          res?.data.map((item) => {
            setTimeout(
              addressline = addressData(item.latitude,item.longitude),
              5000
            )
             
            // const addressData1 = useCallback(async ()=>{
            //   Geocode.fromLatLng(item.latitude , item.longitude,'AIzaSyAWSfp11ay0zsj1xJ5aiNwZcZgz73CHTvs').then(
            //     (response) => {
            //       console.log('dddd',response)
            //       // address = response.results[0].formatted_address;
            //       // setAddressBar(response.results[0].formatted_address);
            //       // console.log('api call',response.results[0].formatted_address);
            //       // console.log('api call addressBar',addressBar,'dfgdfg');
          
            //       return response.results[0].formatted_address;
            //     },
            //     (error) => {
            //       // console.log('irfan');
            //       console.error(error);
            //     }
            //   );
            // })
            // console.log(addressline);
            // console.log('new api response');
            var var1 = {
              totalNo: i,
              address: addressTest,
              startTime: moment(item.startTime).format('DD-MM-YYYY HH:mm:ss'),
              endtime: moment(item.endtime).format('DD-MM-YYYY HH:mm:ss'),
              miles: item.miles,
              duration: moment((item.endtime)-(item.startTime)).format('HH:mm:ss'),
            };
            var var2 = {
              lat: item.latitude,
              lng: item.longitude,
              id: i
            }
            i++;
            arr2.push(var2);
            arr1.push(var1);
            
          });
          
          setCoords(arr2);
          setData(arr1);
          // setCoords(Coords1);
          // console.log('Coords',Coords);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const getTime = (val) => {
    const endTime = Math.round(new Date().getTime() / 1000);
    const startTime = endTime - val * 3600;

    //filter.endDate = endTime;
    //filter.startDate = startTime;
  };
  const initMap = ()=> {
    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 4,
      center: { lat: 28.53549, lng: 77.391029 }, // Australia.
    });
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer({
      draggable: true,
      map,
    });
  
    
    displayRoute(
      "Porbandar, Gujarat",
      "Silchar, Assam",
      directionsService,
      directionsRenderer
    );
  }
  const displayRoute = (origin, destination, service, display)=> {
    service
      .route({
        origin: origin,
        destination: destination,
        waypoints: [
          { location: "Ahmadabad" },
          { location: "Rajasthan" },
          { location: "Jaipur" },
          { location: "lucknow" },
          { location: "Patna" },
          { location: "Jharkhand" },
          { location: "Nagpur" },
          { location: "Indore" },
          { location: "Surat" },
          { location: "Junagadh" },
        ],
        travelMode: google.maps.TravelMode.DRIVING,
        avoidTolls: true,
      })
      .then((result) => {
        display.setDirections(result);
      })
      .catch((e) => {
        alert("Could not display directions due to: " + e);
      });
  }
  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.state = headerFilterObj.state;
      filter.city = headerFilterObj.city;
      filter.zoneId = headerFilterObj.zoneId;
    }

    // const mapAPI= async()=>{
    //   const res = await fetch()
    // }
    window.initMap = initMap;
  }, []);
  return (
    <>
      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
        {userRole.toLowerCase() === "admin"
          ? "Track"
          : "Track"}
      </h2>
      <div className={cn(styles.card_list_block, styles.card_list_block_layout)}>
        <div className={cn(styles.map_card)}>
          <div className={cn(styles.flex6, styles.flex6_layout)}>
            <div className={cn(styles.flex7, styles.flex7_layout)}>
              <div className={cn(styles.flex7_item)}>
                <Search
                  name="batterySerial"
                  id="batterySerial"
                  onSearch={TrackData} 
                  placeholder="Search"
                />
              </div>
              <div className={cn(styles.flex7_spacer)} />
              <div className={cn(styles.flex5_item)}>
            <div ref={wrapperRef}style={{ cursor: "pointer" }} className={cn( styles.graph_filter_block, styles.graph_filter_block_layout, styles.flex6)}>
              <div className={cn(
                  styles.graph_filter_text_block,
                  styles.graph_filter_text_block_layout, styles.bgBlew, styles.pd10, styles.borderRadius
                )}
              >
                <div className={cn(styles.box16, styles.box16_layout)}>
                  <img
                    src={require("assets/trackingFilter.svg").default}
                    className={cn(styles.box1, styles.box1_layout)}
                  />
                </div>
                <div className={cn(styles.text_body, styles.text_body_layout)}>
                  {"Filters"}
                </div>
              </div>
            <div className={cn(styles.box16, styles.box16_layout)}>           
                <div>
                  {open && (
                    <div id="filter" open={open} ref={wrapperRefInside}>
                      <div
                        className={cn(
                          styles.status1_block,
                          styles.status1_block_layout
                        )}
                      >
                        <div>
                          <select
                            style={{ width: "80%", height: "35px" }}
                            name="time"
                            id="time"
                            onChange={handleChange}
                            value={filter.time}
                          >
                            <option value="-1" disabled>
                            Select Time Period
                            </option>
                            <option value="HOUR_24">Last 24 hours</option>
                            <option value="HOUR_12">Last 12 hours</option>
                            <option value="WEEK">Last 1 week</option>
                            <option value="WEEK_2">Last 2 weeks</option>
                            <option value="MONTH">Last 1 month</option>
                            <option value="MONTH_3">Last 3 months</option>
                          </select>
                        </div>

                        <div>
                          <select
                            style={{ width: "80%", height: "35px" }}
                            name="siteId"
                            id="siteId"
                            onChange={handleChange}
                            value={filter.siteId}
                          >
                            <option value="" disabled selected>
                            Select Site
                            </option>
                            {sitesList.map((obj) => {
                              return <option value={obj.id}>{obj.name}</option>;
                            })}
                          </select>
                        </div>

                        <div>
                          <select
                            style={{ width: "80%", height: "35px" }}
                            name="chargerId"
                            id="chargerId"
                            onChange={handleChange}
                            value={filter.chargerId}
                          >
                            <option value="" disabled selected>
                            Select Swap Station
                            </option>
                            {chargerList.map((obj) => {
                              return <option value={obj.id}>{obj.name}</option>;
                            })}
                          </select>
                        </div>

                        <div>
                          <Button
                            style={{
                              background: "#E3324C",
                              color: "white",
                              margin: "15px 0px 6px 35px",
                              width: "85px",
                              height: "28px",
                            }}
                            onClick={handleClick}
                          >
                            Reset
                          </Button>
                          <Button
                            style={{
                              background: "#23297A",
                              color: "white",
                              margin: "15px 0px 6px 20px",
                              width: "85px",
                              height: "28px",
                            }}
                            onClick={handleClick}
                          >
                            Apply
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div className={cn(
            styles.status_block_map,
            styles.status_block_layout_map
          )} id="map"></div>
        {/* <div
          className={cn(
            styles.status_block_map,
            styles.status_block_layout_map
          )}
        >
          <GoogleMapMarker
          chartData={Coords}
          // Coords={Coords}
          />
        </div> */}
        </div>

        <div
        style={{
          borderRadius: "7px",
          backgroundColor: "#fff",
          marginTop: "20px",
          "box-shadow": "rgb(35 41 122 / 25%) 0px 3px 8px 2px",
        }}
      >
<div className={cn(styles.flex2, styles.flex2_layout, styles.pdt20)}>
        <div className={cn(styles.flex2_item)}>
          <div className={cn(styles.block1, styles.block1_layout)}>
            <img
              src={require("assets/batteryTrackingIcon.svg").default}
              alt="Rectangle 16663"
              className={cn(styles.box1, styles.box1_layout)}
            />
          </div>
        </div>
        <div className={cn(styles.flex2_spacer)} />
        <div className={cn(styles.flex2_item1)}>
          <div className={cn(styles.block2, styles.block2_layout)}>
            <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
           <p> {"Battery Live Track"}
           </p>
           <p>
            3HR 40MIN
           </p>
            </h2>
          <p>
            76 Miles
          </p>
          </div>
        </div>
        </div>
        <div className={cn(styles.flex2, styles.flex2_layout)}>
        <Table columns={columns} data={data} />
      </div>
      </div>
      </div>
    </>
  );
}
  return (
    <>
      <Master opts={props} screen={TrackView} showStatus={true} />
    </>
  );
}

Track.inStorybook = true;
